<template>
  <b-card>
    <!-- Header -->
    <div
      class="d-flex align-items-center justify-content-between px-1 my-0 py-0"
      :style="headerStyle"
      @click="toggle"
    >
      <div class="d-flex align-items-center gap-2">
        <feather-icon
          icon="FilterIcon"
          size="18"
        />

        <span class="ml-1 filter-text">
          {{ title }}

          <b-badge
            v-if="appliedFilterCount > 0"
            variant="primary"
            class="d-inline-flex align-items-center justify-content-center rounded-circle"
            style="width: 24px; height: 24px;"
          >
            {{ appliedFilterCount }}
          </b-badge>
        </span>
      </div>

      <feather-icon
        :icon="isCollapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'"
        size="16"
      />
    </div>

    <!-- Body -->
    <div
      v-show="!isCollapsed"
      class="p-1"
    >
      <slot />
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BBadge,
} from 'bootstrap-vue'

export default {
  name: 'FilterCard',
  components: {
    BCard,
    BBadge,
  },
  props: {
    appliedFilterCount: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: 'Filters',
    },
    defaultCollapsed: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isCollapsed: this.defaultCollapsed,
    }
  },

  computed: {
    headerStyle() {
      return {
        cursor: 'pointer',
        minHeight: '10px',
        transition: 'all 0.3s ease',
      }
    },
  },

  methods: {
    toggle() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>
